import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import {
	Card,
	Checkbox,
	Col,
	FieldWrapper,
	Heading,
	Input,
	Row,
	Svg,
	TertiaryButton,
	Text,
} from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScreenSize } from '../../../../enums';

export const FiltersContainer = styled(Card)`
	background-color: ${palette.mlcWhite};
	display: block;
	position: relative;
	width: 100%;
	z-index: 2;
`;

export const CloseButton = styled(TertiaryButton)`
	position: absolute;
	right: 0;
	top: -2px;
`;

export const CloseIcon = styled(Svg)`
	margin-left: 5px;
`;

//Might change this to be put on FieldWrapper props but not working at the moment
export const Divider = styled.hr`
	border-top: thin solid;
	color: ${palette.mlcLightGrey};
	margin: 0 0 30px 0;
	width: 100%;
`;

export const ButtonGroupContainer = styled.div`
	border-top: 1px ${palette.mlcMediumGrey} solid;
	box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
	display: flex;
	height: 100px;
	justify-content: center;
`;

//General button selector e.g. button { width: 200px; } not working in this case
export const ClearApplyButtonGroup = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	button:first-child {
		margin-bottom: 0;
		width: 200px;
	}

	button:last-child {
		width: 200px;
	}

	@media (max-width: ${ScreenSize.small}) {
		button:first-child,
		button:last-child {
			margin: 0 15px;
			width: 125px;
		}
	}
`;

export const PopoutArrow = styled(Svg)`
	color: ${palette.mlcWhite};
	display: block;
	position: absolute;
`;

export const FormContentWrapper = styled.div`
	height: 400px;
	overflow: auto;
	padding: 30px 60px 50px 30px;
	position: relative;
`;
